import { render, staticRenderFns } from "./BatchReading.vue?vue&type=template&id=68c94ed4&scoped=true"
import script from "./BatchReading.vue?vue&type=script&lang=js"
export * from "./BatchReading.vue?vue&type=script&lang=js"
import style0 from "./BatchReading.vue?vue&type=style&index=0&id=68c94ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c94ed4",
  null
  
)

export default component.exports